import axios from 'axios'
import { t } from '@/i18n/helpers'

import store from '../../src/store'

var globalToken = ''

var globalIsLocalStorageAvailable = 'unchecked'
// 全局缓存 Map
const globalMap = {};

//慎用true/false，因为放到storage后转换比较难控制。直接用“0” / "1"
export default {
  isLocalStorageAvailable() {
    if (globalIsLocalStorageAvailable == 'yes') {
      return true
    }
    if (globalIsLocalStorageAvailable == 'no') {
      return false
    }
    try {
      const testKey = "__test_key__";
      window.localStorage.setItem(testKey, "1");
      const value = window.localStorage.getItem(testKey);
      if (value !== "1") {
        throw new Error("Failed to read after writing to localStorage");
      }
      window.localStorage.removeItem(testKey);
      // this.uploadLog("local_storage_available", { url: window.location.href })
      globalIsLocalStorageAvailable = 'yes'
      return true;
    } catch (e) {
      console.warn("localStorage unavailable, using Cookie instead");
      this.uploadLog("local_storage_unavailable", { url: window.location.href })
      globalIsLocalStorageAvailable = 'no'
      return false;
    }
  },
  setCookie(name, value, options = {}) {
    let cookieString = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
    if (options.expires) {
      const date = new Date();
      date.setTime(date.getTime() + options.expires * 24 * 60 * 60 * 1000); // 天数转毫秒
      cookieString += `; expires=${date.toUTCString()}`;
    }
    if (options.path) cookieString += `; path=${options.path}`;
    if (options.domain) cookieString += `; domain=${options.domain}`;
    if (options.secure) cookieString += "; secure";
    document.cookie = cookieString;
  },
  getCookie(name) {
    const cookies = document.cookie.split("; ");
    for (const cookie of cookies) {
      const [key, value] = cookie.split("=");
      if (decodeURIComponent(key) === name) {
        return decodeURIComponent(value);
      }
    }
    return null;
  },
  deleteCookie(name, options = {}) {
    // 设置过期时间为过去时间
    this.setCookie(name, "", {
      ...options,
      expires: -1 // 过期时间设为过去
    });
  },
  // 设置通用键值（自动选择 localStorage 或 Cookie）
  async setKey(key, value) {
    // 更新全局缓存
    globalMap[key] = value;
    if (this.isLocalStorageAvailable()) {
      try {
        window.localStorage.setItem(key, value);
      } catch (e) {
        // 如果设置 localStorage 失败，回退到 Cookie
        this.setCookie(key, value, { expires: 7 }); // 默认 7 天过期
      }
    } else {
      // 直接使用 Cookie
      this.setCookie(key, value, { expires: 7 });
    }
  },
  // 获取通用键值（自动选择 localStorage 或 Cookie）
  getKey(key) {
    if (!globalMap[key]) {
      if (this.isLocalStorageAvailable()) {
        globalMap[key] = window.localStorage.getItem(key);
      } else {
        globalMap[key] = this.getCookie(key);
      }
    }
    return globalMap[key];
  },
  removeKey(key) {
    // 清除全局缓存
    delete globalMap[key];
    if (this.isLocalStorageAvailable()) {
      try {
        window.localStorage.removeItem(key);
      } catch (e) {
        // 如果删除 localStorage 失败，尝试删除 Cookie
        this.deleteCookie(key);
      }
    } else {
      // 直接删除 Cookie
      this.deleteCookie(key);
    }
  },
  async uploadLog(type, info) {
    try {
      var url = '/upload_log/' + type
      if (info) {
        url = url + "?" + this.objectToQueryString(info)
      }
      await axios.get(url)
    } catch (error) {
      console.error("Failed to upload log:", error)
    }
  },
  //https://www.altcademy.com/blog/how-to-turn-an-object-into-query-string-parameters-in-reactjs/
  objectToQueryString(obj) {
    const keys = Object.keys(obj);
    const keyValuePairs = keys.map(key => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
    });
    return keyValuePairs.join('&');
  },
  // 格式化毫秒时间戳为本地时间字符串（yyyy/MM/dd HH:mm）
  // 所有显示层统一用此函数，不再依赖服务端预格式化的 createdAtText
  formatDateTime(ms) {
    if (!ms || ms <= 0) return ''
    var d = new Date(Number(ms))
    var dd = String(d.getDate()).padStart(2, '0')
    var mm = String(d.getMonth() + 1).padStart(2, '0')
    var yyyy = d.getFullYear()
    var hh = String(d.getHours()).padStart(2, '0')
    var min = String(d.getMinutes()).padStart(2, '0')
    return yyyy + '/' + mm + '/' + dd + ' ' + hh + ':' + min
  },
  // 格式化毫秒时间戳为本地短日期（MM/dd HH:mm）
  formatMMDDHHMM(ms) {
    if (!ms || ms <= 0) return ''
    var d = new Date(Number(ms))
    var dd = String(d.getDate()).padStart(2, '0')
    var mm = String(d.getMonth() + 1).padStart(2, '0')
    var hh = String(d.getHours()).padStart(2, '0')
    var min = String(d.getMinutes()).padStart(2, '0')
    return mm + '/' + dd + ' ' + hh + ':' + min
  },
  // 智能相对时间格式化（基于用户本地时区）
  // 1分钟内：刚刚 / Just now
  // 1小时内：X分钟前 / X min ago
  // 今天：HH:mm
  // 昨天：昨天 HH:mm / Yesterday HH:mm
  // 前天：前天 HH:mm / 2d ago HH:mm
  // 一周内：X天前 / Xd ago
  // 超过一周：更早 / Earlier
  formatSmartTime(ms, locale) {
    if (!ms || ms <= 0) return ''
    var date = new Date(Number(ms))
    var now = new Date()
    var diff = now.getTime() - date.getTime()
    var oneDayMs = 24 * 60 * 60 * 1000
    var oneWeekMs = 7 * oneDayMs
    var isCn = locale === 'zh'
    var hour = String(date.getHours()).padStart(2, '0')
    var min = String(date.getMinutes()).padStart(2, '0')
    var timeStr = hour + ':' + min
    // 今天零点（用户本地时区）
    var todayStart = new Date(now.getFullYear(), now.getMonth(), now.getDate())
    var todayStartMs = todayStart.getTime()
    if (diff < 60 * 1000) {
      return isCn ? '刚刚' : 'Just now'
    }
    if (diff < 60 * 60 * 1000) {
      var mins = Math.floor(diff / (60 * 1000))
      return isCn ? (mins + '分钟前') : (mins + ' min ago')
    }
    if (date.getTime() >= todayStartMs) {
      return timeStr
    }
    if (date.getTime() >= todayStartMs - oneDayMs) {
      return (isCn ? '昨天 ' : 'Yesterday ') + timeStr
    }
    if (date.getTime() >= todayStartMs - 2 * oneDayMs) {
      return (isCn ? '前天 ' : '2d ago ') + timeStr
    }
    if (diff < oneWeekMs) {
      var days = Math.floor(diff / oneDayMs)
      return isCn ? (days + '天前') : (days + 'd ago')
    }
    return isCn ? '更早' : 'Earlier'
  },
  dateToDateStr(date) {
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();
    return yyyy + '/' + mm + '/' + dd;
  },
  getUserId() {
    return this.getKey('jwt_user_id')
  },
  getToken() {
    return this.getKey('jwt_token')
  },
  async setToken(userId, token) {
    if (userId) {
      await this.setKey('jwt_user_id', userId)
    }
    if (token) {
      await this.setKey('jwt_token', token)
    }
  },
  async clearTokenHeader() {

    this.removeKey('jwt_token')
    this.removeKey('jwt_user_id')

    // 移除拦截器
    if (this.axiosInterceptor) {
      axios.interceptors.request.eject(this.axiosInterceptor)
      this.axiosInterceptor = null
    }
  },
  setTokenHeader() {
    // 移除已有的拦截器（避免重复注册）
    if (this.axiosInterceptor) {
      axios.interceptors.request.eject(this.axiosInterceptor)
    }

    this.axiosInterceptor = axios.interceptors.request.use(config => {
      if (globalMap['jwt_token']) {
        config.headers.token = globalMap['jwt_token']
      }
      if (globalMap['jwt_user_id']) {
        config.headers['baggage-user-id'] = globalMap['jwt_user_id']
      }
      return config
    }, error => {
      return Promise.reject(error)
    })
  },
  handleLoginSuccess(data) {
    // 保存 token
    this.setTokenHeader()
    this.setToken(data.user.userId, data.token)
    // 更新登录状态
    store.state.alreadyLogin = true
    store.state.needLogin = false
    store.state.user = data.user
    window.location.reload()
  },
  // getLocalStorageValue(key) {
  //   return window.localStorage.getItem(key)
  // },
  // setLocalStorageValue(key, value) {
  //   window.localStorage.setItem(key, value)
  // },
  setNotLoginHandler() {

    let tmp = this
    axios.interceptors.response.use(
      response => {
        if (response && response.data && response.data.code && (response.data.code === 401 || response.data.code === 402)) {
          tmp.clearTokenHeader()

          // 402 代表token不兼容了，故意要求本地token清空后重新签发，所以本地重新刷新一下即可
          if (response.data.code === 402) {
            window.location.reload()
          }
          // return Promise.reject(new Error('Unauthorized'))
          return response
        }
        return response
      },
      error => {
      })
  },
  updateURLParameter(url, param, paramVal) {
    if (!url.includes('?')) {
      return url += '?' + param + '=' + paramVal;
    } else if (!url.includes(param)) {
      return url += '&' + param + '=' + paramVal;
    } else {
      let paramStartIndex = url.search(param);
      let paramEndIndex = url.indexOf('&', paramStartIndex);
      if (paramEndIndex == -1) {
        paramEndIndex = url.length;
      }
      let brands = url.substring(paramStartIndex, paramEndIndex);

      return url.replace(brands, param + '=' + paramVal);
    }
  },
  dateToYYYYMMDD(date) {
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();
    return yyyy + '/' + mm + '/' + dd;
  },
  dateToYYYYMMDDHHMM(date) {
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = date.getFullYear();
    var hour = String(date.getHours()).padStart(2, '0');
    var min = String(date.getMinutes()).padStart(2, '0');
    return yyyy + '/' + mm + '/' + dd + ' ' + hour + ':' + min
  },
  dateToMMDDHHMM(date) {
    var dd = String(date.getDate()).padStart(2, '0');
    var mm = String(date.getMonth() + 1).padStart(2, '0'); //January is 0!
    var hour = String(date.getHours()).padStart(2, '0');
    var min = String(date.getMinutes()).padStart(2, '0');
    return mm + '/' + dd + ' ' + hour + ':' + min
  },
  //https://gist.github.com/mikey0000/5a078346f58713d0075f
  async convertToJpegAndResize(document, content, width) {
    var image = new Image();
    image.src = content
    await image.decode();
    var canvas = document.createElement("canvas");
    var ratio = parseFloat(image.height) / image.width
    canvas.width = width;
    canvas.height = Math.floor(width * ratio);
    canvas.getContext("2d").drawImage(image, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL("image/jpeg")
  },
  removeQueryParam(url, paramsToRemove) {
    var tmp = url.split('?')
    if (tmp.length == 1) {
      return url
    }
    // 解析哈希中的查询字符串
    const params = new URLSearchParams(tmp[1]);

    // 创建一个新的URLSearchParams对象，用于存储未被移除的参数
    const filteredParams = new URLSearchParams();

    // 遍历所有参数并添加到新的URLSearchParams对象中，除非它们在paramsToRemove数组中
    for (const [key, value] of params.entries()) {
      if (!paramsToRemove.includes(key)) {
        filteredParams.set(key, value);
      }
    }

    // 构建新的字符串
    const newParams = `${filteredParams.toString()}`;
    if (newParams) {
      return tmp[0] + "?" + newParams;
    } else {
      return tmp[0];
    }
  },
  calculateDistance(srcLat, srcLng, dstLat, dstLng) {
    // 地球半径，单位为米
    const R = 6371000; // 地球平均半径约为6371公里

    // 将角度转换为弧度
    const radSrcLat = srcLat * Math.PI / 180;
    const radDstLat = dstLat * Math.PI / 180;
    const deltaLat = (dstLat - srcLat) * Math.PI / 180;
    const deltaLng = (dstLng - srcLng) * Math.PI / 180;

    // Haversine公式
    const a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
      Math.cos(radSrcLat) * Math.cos(radDstLat) *
      Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    // 计算距离
    const distance = R * c;
    return distance;
  },
  limitLength(s, len) {
    if (s.length <= len) {
      return s;
    }
    return s.substring(0, len - 2) + t('ellipsis')
  },
  generateUUID() {
    // 优先尝试使用现代浏览器的 crypto.randomUUID() 方法
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }

    // 其次使用 crypto.getRandomValues() 方法（更广泛的浏览器支持）
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
      const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
      return pattern.replace(/[xy]/g, function (character) {
        const randomValues = new Uint8Array(1);
        crypto.getRandomValues(randomValues);
        const randomNumber = randomValues[0] % 16;
        const value = character === 'x' ? randomNumber : (randomNumber & 0x3 | 0x8);
        return value.toString(16);
      });
    }

    // 最后回退到基于时间戳和Math.random()的兼容方案
    let timestamp = Date.now();
    let performanceIndicator = (typeof performance !== 'undefined' && performance.now) ?
      performance.now() * 1000 : 0;

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (character) {
      let randomNumber = Math.random() * 16;

      if (timestamp > 0) {
        randomNumber = (timestamp + randomNumber) % 16 | 0;
        timestamp = Math.floor(timestamp / 16);
      } else {
        randomNumber = (performanceIndicator + randomNumber) % 16 | 0;
        performanceIndicator = Math.floor(performanceIndicator / 16);
      }

      const value = character === 'x' ? randomNumber : (randomNumber & 0x3 | 0x8);
      return value.toString(16);
    });
  },
  // 获取完整的图片URL（根据配置的CDN host拼接）
  // size 可选头像尺寸后缀：s (96x96) / m (256x256) / l (512x512)
  getFullImageUrl(imagePath, config, size) {
    if (!imagePath) return ''

    const lowerSize = typeof size === 'string' ? size.toLowerCase() : ''
    const hasSize = lowerSize === 's' || lowerSize === 'm' || lowerSize === 'l'

    const appendSize = (path) => {
      if (!hasSize) return path
      // l 是大图，对应 base path 本身，不加后缀
      if (lowerSize === 'l') return path
      const lastDot = path.lastIndexOf('.')
      if (lastDot <= 0) return path
      const ext = path.substring(lastDot)
      const base = path.substring(0, lastDot)
      return base + '_' + lowerSize + ext
    }

    const imgCdnHost = config && config.imgCosUrl ? config.imgCosUrl : 'https://img.cdn.octosay.ai'

    // 如果已经是本 CDN 的完整URL，截出相对 path 加后缀后再拼回
    if (imagePath.startsWith(imgCdnHost)) {
      let relativePath = imagePath.substring(imgCdnHost.length)
      let query = ''
      const queryIndex = relativePath.indexOf('?')
      if (queryIndex >= 0) {
        query = relativePath.substring(queryIndex)
        relativePath = relativePath.substring(0, queryIndex)
      }
      return imgCdnHost + appendSize(relativePath) + query
    }

    // 其他完整URL无法确定尺寸规则，直接返回原图
    if (imagePath.startsWith('http://') || imagePath.startsWith('https://')) {
      return imagePath
    }

    // 如果是不包含host的path，根据配置的CDN host拼接完整URL
    const path = imagePath.startsWith('/') ? imagePath : '/' + imagePath

    return imgCdnHost + appendSize(path)
  },
  // 将 userMsg 转换为可读的纯文本预览（mixed JSON 数组时提取 plaintext，img/file 显示占位符；解析失败或普通文本原样返回）
  formatUserMsgPreview(userMsg) {
    if (!userMsg) return ''
    let parsed = null
    try {
      if (Array.isArray(userMsg)) {
        parsed = userMsg
      } else if (typeof userMsg === 'string') {
        parsed = JSON.parse(userMsg)
      }
    } catch (e) {
      parsed = null
    }
    if (!parsed || !Array.isArray(parsed) || parsed.length === 0) {
      return typeof userMsg === 'string' ? userMsg : JSON.stringify(userMsg)
    }
    let parts = []
    for (let i = 0; i < parsed.length; i++) {
      const item = parsed[i]
      if (!item) continue
      if (item.type === 'plaintext') {
        const content = typeof item.content === 'string' ? item.content : (item.content ? JSON.stringify(item.content) : '')
        if (content) parts.push(content)
      } else if (item.type === 'img') {
        parts.push(t('summary_image'))
      } else if (item.type === 'file') {
        parts.push(t('summary_file'))
      } else if (item.type === 'video') {
        parts.push(t('summary_video'))
      } else if (item.type === 'pick_location') {
        parts.push(t('summary_location'))
      } else if (item.type === 'audio') {
        parts.push(t('summary_voice'))
      }
    }
    const text = parts.join(' ')
    if (!text) {
      // 全部是图片/文件/语音等无文本内容时，给一个兜底占位
      if (parsed.some(function (it) { return it && it.type === 'img' })) return t('summary_image')
      if (parsed.some(function (it) { return it && it.type === 'file' })) return t('summary_file')
      if (parsed.some(function (it) { return it && it.type === 'video' })) return t('summary_video')
      if (parsed.some(function (it) { return it && it.type === 'audio' })) return t('summary_voice')
      return userMsg
    }
    return text
  }
}


// WEBPACK FOOTER //
// ./src/assets/common.js